/**
 * Card (Local Stub)
 */

import type { CSSProperties, ReactNode } from 'react';
import { tokens } from './tokens';

export interface CardProps {
  children: ReactNode;
  variant: 'elevated' | 'outline' | 'ghost';
  padding: 'sm' | 'md' | 'lg';
  hover: null;
}

const paddingMap = {
  sm: tokens.spacing[2],
  md: tokens.spacing[4],
  lg: tokens.spacing[6],
};

export function Card({ children, variant, padding }: CardProps) {
  const style: CSSProperties = {
    backgroundColor: variant === 'ghost' ? 'transparent' : tokens.colors.surface,
    border: variant === 'outline' ? `1px solid ${tokens.colors.border}` : 'none',
    boxShadow: variant === 'elevated' ? '0 4px 6px rgba(0, 0, 0, 0.3)' : 'none',
    borderRadius: tokens.radii.lg,
    padding: paddingMap[padding],
  };

  return <div style={style}>{children}</div>;
}
